export default __webpack_public_path__ + "static/media/avatar-2.0fdabd61.jpg";